import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");

        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        api.post("/auth/session", { session_id: sessionId })
            .then((res) => {
                setUser(res.data);
                // clean hash
                window.history.replaceState(null, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: res.data } });
            })
            .catch(() => {
                navigate("/login", { replace: true });
            });
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-brand-void">
            <div className="text-center">
                <div className="w-8 h-8 mx-auto rounded-full border-2 border-white/10 border-t-brand-indigo animate-spin" />
                <p className="mt-4 text-sm text-zinc-500 font-mono">Establishing session…</p>
            </div>
        </div>
    );
}
